<template>
  <div class="animated fadeIn">
    <b-card v-if="!partner && model && model.id">
      <h5 block>
      {{model.permissions || '-'}}
      Partner : {{model.username || '-'}}
      <span class="pull-right">
        {{model.nickname || '-'}}
      </span>
      </h5>
    </b-card>
    <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-danger" v-model="index">
      <b-tab :title="partner || (model && model.id) ? 'Partner' : 'Partner Generation'" border-variant="primary" >
        <div slot="header">
          <strong>Partner Information</strong>
          <span class="pull-right" v-if="!add && model.created_at">Joined_at  : {{model.created_at | datetime}}</span>
        </div>
        <b-row>
          <b-col md="3">
            <b-form-group label="Allow login" label-for="ph_use"
              v-b-tooltip.hover title="Allow login.">
              <c-switch color="info" label size="sm" v-model="model.is_alive" :disabled="lock" />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label>Permissions</label>
              <label for="ph_group" v-b-tooltip.hover title="Permission."></label>
              <v-select :disabled="model && !model.parent_id" v-if="!lock" label="text" v-model="model.permissions" :options="codes.permissions_partner"></v-select>
              <b-form-input type="text" v-if="lock" :value="model.permissions" plaintext></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="model.id">
            <b-form-group>
              <label>Last_visit</label>
              <p>
                {{model.last_visit | datetime}} @ {{model.last_addr}}
              </p>
            </b-form-group>
          </b-col>
          <b-col md="6" v-else>
            <b-form-group>
              <label v-if="model && !model.parent_id">
                Partner Group connect
                <br>
                <small>If the partner being created belongs to the same group as the other partner</small>
              </label>
              <label v-else>Partner Group : {{model.parent_username}}</label>
              <b-button variant="primary" @click="partner_connect_modal = true" block>Search</b-button>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group v-if="model.parent_id && model.parent_id != model.id && lock">
              <label>Partner Group Owner</label>
              <label>{{model.parent_username}}</label>
              <b-button v-show="!(model.parent_id && model.parent_id == model.id)" variant="primary" @click="reload" block>View</b-button>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="ph_username" v-b-tooltip.hover title="Username">Username(ID) (*)
                <span v-if="model.is_del" class="text-danger">Deleted user, Logging in is not possible even if you allow it.</span>
              </label>
              <b-badge v-if="model && model.id && model.parent_id"  :variant="model.parent_id && model.parent_id == model.id ? 'success' : 'primary'">
                * Partner Group {{model.parent_id && model.parent_id == model.id ? ' Master' : 'Member'}}
              </b-badge>
              <b-form-input :disabled="!add || lock" type="text" id="ph_username" v-model="model.username" :plaintext="lock" ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-show="add || !lock">
          <b-col md="6">
            <b-form-group>
              <label for="ph_pass">{{add ? 'User' : 'Change'}} Password(*)</label>
              <b-form-input type="password" id="ph_pass" v-model="model.new_password" :plaintext="lock"></b-form-input>
              <b-badge v-if="model.new_password"  :variant="password_policy('number') ? 'success' : 'danger'"> Number </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> Upper Characters </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> Lower Characters </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('spacial') ? 'success' : 'danger'"> Special Characters </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('length') ? 'success' : 'danger'">
                Min Length : 10
              </b-badge>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="model.new_password">
            <b-form-group>
              <label for="ph_pass2">Password Repeat(*)</label>
              <b-form-input type="password" id="ph_pass2" v-model="model.new_password_repeat" :plaintext="lock"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group>
              <label for="ph_nickname">Nick Name(*)</label>
              <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Invoice Email Notice" v-b-tooltip.hover title="Sets whether issued invoice is sent or not. Only 'Owner' accounts can be set.">
              <c-switch :disabled="lock || model.parent_id && model.parent_id != model.id" color="info" label size="sm" v-model="model.allow_invoice"/>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label for="ph_tax">Tax : [%]</label>
              <b-form-input type="number" id="ph_tax" v-model="model.tax" :plaintext="lock"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <h4>Region</h4>
        <hr>
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label for="ph_country_group" v-b-tooltip.hover title="country">Country(*)</label>
              <v-select :readonly="true" :disabled="lock" label="name" v-model="region.country" :options="codes.country" ></v-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="ph_language_group" v-b-tooltip.hover title="language">language(*)</label>
              <v-select :readonly="true" label="name" :disabled="lock" v-model="region.language" :options="codes.language"></v-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="ph_timezone_group" v-b-tooltip.hover title="Timezone">Timezone(*)</label>
              <v-select :readonly="true" label="name" :disabled="lock" v-model="region.timezone" :options="codes.timezone" ></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="ph_address" v-b-tooltip.hover title="Address for billing">Address(*)</label>
              <b-form-input type="text" id="ph_address" v-model="model.address" :plaintext="lock"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="ph_group" v-b-tooltip.hover title="Enter a single IP or network range, etc) 192.168.0.100, 192.168.0.0/24 ">List of allowed IPs</label>
              <b-form-textarea ref="allow_ip_list" :rows="model && model.allow_ip ? model.allow_ip.length + 2 : 0" max-rows="10" v-model="model.allow_ip_list" :plaintext="lock"></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <span>* The logo is using when Invoice</span>
            <img v-if="lock" class="text-center" height="120" width="400" :src="model.logo || 'img/F1-uwss.png'" alt="Hello, F1security">
            <b-form-group v-else>
              <!-- v-show="!confirm_save && !confirm_refresh" -->
              <picture-input
                :z-index="2"
                radius="3"
                :prefill="model.logo"

                ref="pictureInput"
                height="140" min-height="150" width="600"  max-width="600" max-height="200"
                accept="image/*" size="2" button-class="btn btn-dark"
                :custom-strings="{
                  upload: '<h1>uploading</h1>',
                  drag: '<small>Drag & Drop<small>',
                }"
                @change="logo_change">
              </picture-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
      </b-tab>
    </b-tabs>
    <router-view></router-view>
  </div>
</template>

<style>
.g {
  /* width: 33px; */
  height: 100%;
}

/* .nav-tabs .nav-link{
  border-color : #c8ced3
} */
</style>

<script>

const default_model = () => (
  { is_alive : true, permissions : 'Owner', is_del : false, parent_id : null, parent_username : '', tax : 0.00, allow_invoice : false }
);

let default_opt = function() {
  return {
    perPage: 15,
    currentPage: 1, totalRows: 0,
    sk: '', sv: '', skt: '', opt : {}, adv : false
  }
}

import codes from '@/codes';
import reg from '@/reg';
import { Api } from '@/service';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import * as forge from 'node-forge'
import * as _ from 'lodash';
import moment from 'moment-timezone';

// another vue
import groupList from '../group/Group.List'
import partnerList from './Partner.List'
import logLoginList from '../../Log/login/Login.List.Partner'
import logActionList from '../../Log/action/Action.List.Partner'
import SettingService from  '../../System/setting/Setting.Service'
import PictureInput from 'vue-picture-input' // https://github.com/alessiomaffeis/vue-picture-input good boy

// invoice
import InvoicePartnerList from '../../Billing/invoice.partner/Invoice.List'
import VueMonthlyPicker from 'vue-monthly-picker'

export default {
  props : ["partner", 'partner_id'],
  watch: {
    '$route' (to, from) { this.get(to.params, "from", from); },
    partner() {
      console.log("watch updated props data")
      this.model = this.partner
      let is_done_country = false;
      codes.country.forEach(r => { if(is_done_country) { return; } else if(this.model.country && r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

      let is_done_language = false;
      codes.language.forEach(r => { if(is_done_language) { return; } else if(this.model.language && r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

      let is_done_timezone = false;
      codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });
    }
  },
  components: {
    VueMonthlyPicker,
    InvoicePartnerList,
    PictureInput,
    cSwitch,
    vSelect,
    groupList,
    logLoginList,
    logActionList,
    partnerList,
    SettingService
  },
  data : () => {
		return {
      ticket_invoice_month : '',
      confirm_ticket_invoice : false,
      logo : '',
      publish_list : [],
      published_list : [],
      new_service_id : 0,
      service_append_confirm : false,
      mail_confirm : false,
      is_registed : false,
      index : 0,
      credit_history_opt : default_opt(),
      Credit_Add : false,
      credit_history_modal : false,
      Credit_History : undefined,
      amount : 0.00,
      amount_log : '',
      setting_modify_confirm : false,
      setting_modify : false,
      setting_modify_index : -1,
      partner_price : [],
      codes,
      confirm: false,
      add: false,
      lock: true,
      group_list: undefined,
      model : Object.assign({}, default_model()),
      allowed: false,
      partner_connect_modal : false,
      region : {
        language : codes.language_default,
        country : codes.country_default,
        timezone : codes.timezone_default
      },
      password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false  },
      published : false
    }
  },
  computed: {
  },
  methods: {
    async get() {
      this.model = default_model()
      console.log(this.partner_id, 'this.partner_id')
      if(!this.partner_id) { return this.$toastr.e('incorrect target partner') }

      try{
        this.add = false;
        if(this.partner) {
          this.model = this.partner;
        } else {
          let rs = await Api.Manager_Call('partner', 'detail', { id : this.partner_id })
          if(rs.error) { return this.$toastr.e("load failed", this.$route.name); }
          this.model = Object.assign({ group: {} }, this.model, rs.body)
        }

        let is_done_country = false;
        codes.country.forEach(r => { if(is_done_country) { return; } else if(this.model.country && r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

        let is_done_language = false;
        codes.language.forEach(r => { if(is_done_language) { return; } else if(this.model.language && r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

        let is_done_timezone = false;
        codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });

        if(this.model.permissions.toLowerCase() == 'owner') {
          this.is_registed = this.model.updated_at == this.model.created_at
        } else { console.log("this partner not owner, so price is lock") }

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list() }
    }
  },
  created() { console.log('partner_Detail.vue', 'created'); },
  destroyed() { console.log('partner_Detail.vue', 'destroyed'); },
  mounted() {
    console.log('partner_Detail.vue', 'mounted');
    this.get();
  },
}
</script>
